import { C } from "./shared";

export default function LoadingScreen() {
  return (
    <div style={{ minHeight:"100vh", background:C.dark, display:"flex", alignItems:"center", justifyContent:"center", fontFamily:"'DM Sans',sans-serif" }}>
      <div style={{ textAlign:"center" }}>
        <div style={{ fontSize:28, fontWeight:900, marginBottom:16 }}>
          <span style={{ color:C.red }}>Quote</span><span style={{ color:C.text }}>MyBodywork</span>
        </div>
        <div style={{ width:32, height:32, border:`3px solid ${C.border}`, borderTopColor:C.red, borderRadius:"50%", margin:"0 auto", animation:"spin 0.8s linear infinite" }} />
        <style>{`@keyframes spin{to{transform:rotate(360deg)}}`}</style>
      </div>
    </div>
  );
}
